module.exports = __webpack_public_path__ + "img/fma_1.452c2696.gif";